import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { Header, Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Card = styled(SegmentLayoutComponent)`
  height: 390px;
  width: 650px;
  display: flex;
  justify-content: center;
  align-items: center;
  &.ui.segment {
    padding: 30px;
  }
`;

const Title = styled(Header)`
  font-size: 27px;
  font-weight: 500;
  text-align: center;
`;

const InvitationText = styled(TextLayoutComponent)`
  margin-top: 12px;
  font-size: 20px;
  margin-bottom: 24px;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 70px 25%;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const DateContainer = styled(TextLayoutComponent)`
  font-size: ${({ theme }) => theme.fontSize.textTitle};
`;

const Link = styled(RouterLink)`
  margin-top: 15px;
`;

export {
  Card,
  Container,
  Content,
  InvitationText,
  DateContainer,
  Link,
  Title,
};
